import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Import Kyrgyzstan images
import kyrgyzstan1 from '../images/kyrgyzstan1.jpeg';
import kyrgyzstan2 from '../images/kyrgyzstan2.jpeg';
import kyrgyzstan3 from '../images/kyrgyzstan3.jpeg';
import kyrgyzstan4 from '../images/kyrgyzstan4.jpeg';
import kyrgyzstan5 from '../images/kyrgyzstan5.jpeg';
import kyrgyzstan6 from '../images/kyrgyzstan6.jpeg';
import kyrgyzstan7 from '../images/kyrgyzstan7.jpeg';
import kyrgyzstan8 from '../images/kyrgyzstan8.jpeg';
import kyrgyzstan9 from '../images/kyrgyzstan9.jpeg';
import kyrgyzstan10 from '../images/kyrgyzstan10.jpeg';
import kyrgyzstan11 from '../images/kyrgyzstan11.jpeg';
import kyrgyzstan12 from '../images/kyrgyzstan12.jpeg';
import kyrgyzstan13 from '../images/kyrgyzstan13.jpeg';
import kyrgyzstan14 from '../images/kyrgyzstan14.jpeg';
import kyrgyzstan15 from '../images/kyrgyzstan15.jpeg';
import kyrgyzstan16 from '../images/kyrgyzstan16.jpeg';
import kyrgyzstan17 from '../images/kyrgyzstan17.jpeg';
import kyrgyzstan18 from '../images/kyrgyzstan18.jpeg';
import kyrgyzstan19 from '../images/kyrgyzstan19.jpeg';
import kyrgyzstan20 from '../images/kyrgyzstan20.jpeg';
import kyrgyzstan21 from '../images/kyrgyzstan21.jpeg';
import kyrgyzstan22 from '../images/kyrgyzstan22.jpeg';
import kyrgyzstan23 from '../images/kyrgyzstan23.jpeg';
import kyrgyzstan24 from '../images/kyrgyzstan24.jpeg';
import kyrgyzstan25 from '../images/kyrgyzstan25.jpeg';
import kyrgyzstan26 from '../images/kyrgyzstan26.jpeg';
import kyrgyzstan27 from '../images/kyrgyzstan27.jpeg';
import kyrgyzstan28 from '../images/kyrgyzstan28.jpeg';
import kyrgyzstan29 from '../images/kyrgyzstan29.jpeg';
import kyrgyzstan30 from '../images/kyrgyzstan30.jpeg';
import kyrgyzstan31 from '../images/kyrgyzstan31.jpeg';
import kyrgyzstan32 from '../images/kyrgyzstan32.jpeg';
import kyrgyzstan33 from '../images/kyrgyzstan33.jpeg';
import kyrgyzstan34 from '../images/kyrgyzstan34.jpeg';
import kyrgyzstan35 from '../images/kyrgyzstan35.jpeg';
import kyrgyzstan36 from '../images/kyrgyzstan36.jpeg';
import kyrgyzstan37 from '../images/kyrgyzstan37.jpeg';
import kyrgyzstan38 from '../images/kyrgyzstan38.jpeg';
import kyrgyzstan39 from '../images/kyrgyzstan39.jpeg';
import kyrgyzstan40 from '../images/kyrgyzstan40.jpeg';
import kyrgyzstan41 from '../images/kyrgyzstan41.jpeg';
import kyrgyzstan42 from '../images/kyrgyzstan42.jpeg';
import kyrgyzstan43 from '../images/kyrgyzstan43.jpeg';
import kyrgyzstan44 from '../images/kyrgyzstan44.jpeg';
import kyrgyzstan45 from '../images/kyrgyzstan45.jpeg';
import kyrgyzstan46 from '../images/kyrgyzstan46.jpeg';

function Kyrgyzstan() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    kyrgyzstan1, kyrgyzstan2, kyrgyzstan3, kyrgyzstan4, kyrgyzstan5, kyrgyzstan6,
    kyrgyzstan7, kyrgyzstan8, kyrgyzstan9, kyrgyzstan10, kyrgyzstan11, kyrgyzstan12,
    kyrgyzstan13, kyrgyzstan14, kyrgyzstan15, kyrgyzstan16, kyrgyzstan17, kyrgyzstan18,
    kyrgyzstan19, kyrgyzstan20, kyrgyzstan21, kyrgyzstan22, kyrgyzstan23, kyrgyzstan24,
    kyrgyzstan25, kyrgyzstan26, kyrgyzstan27, kyrgyzstan28, kyrgyzstan29, kyrgyzstan30,
    kyrgyzstan31, kyrgyzstan32, kyrgyzstan33, kyrgyzstan34, kyrgyzstan35, kyrgyzstan36,
    kyrgyzstan37, kyrgyzstan38, kyrgyzstan39, kyrgyzstan40, kyrgyzstan41, kyrgyzstan42,
    kyrgyzstan43, kyrgyzstan44, kyrgyzstan45, kyrgyzstan46
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇰🇬 Kyrgyzstan 2024 🇰🇬</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Kyrgyzstan ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Kyrgyzstan;